document.addEventListener("DOMContentLoaded", () => {
  const items = Array.from(
    document.querySelectorAll(".fashion-gallery-item img")
  );
  const modal = document.getElementById("fashion-gallery-modal");
  const modalLabel = document.getElementById("modal-label");
  const modalImg = document.getElementById("modal-image");
  let currentIndex = 0;
  let startX = 0;

  function openModal(idx) {
    currentIndex = idx;
    const thumb = items[currentIndex];
    const lookText = thumb
      .closest(".fashion-gallery-item")
      .querySelector(".look-label").textContent;
    modalLabel.textContent = lookText;

    modalImg.src = thumb.src;
    modal.classList.remove("hidden");

    const largeURL = thumb.getAttribute("data-large");
    const preloader = new Image();
    preloader.src = largeURL;
    preloader.onload = () => {
      modalImg.src = largeURL;
    };
  }

  items.forEach((img, idx) => {
    img.addEventListener("click", () => openModal(idx));
  });

  modal.addEventListener("click", (e) => {
    if (e.target === modal || e.target.classList.contains("close-modal")) {
      modal.classList.add("hidden");
    }
  });

  modalImg.addEventListener("pointerdown", (e) => {
    startX = e.clientX;
  });

  document.addEventListener("pointerup", (e) => {
    if (modal.classList.contains("hidden")) return;

    const deltaX = e.clientX - startX;
    const THRESHOLD = 50;
    let moved = false;

    if (deltaX > THRESHOLD && currentIndex > 0) {
      currentIndex--;
      moved = true;
    } else if (deltaX < -THRESHOLD && currentIndex < items.length - 1) {
      currentIndex++;
      moved = true;
    }

    if (!moved) return;

    const thumb = items[currentIndex];
    modalImg.src = thumb.getAttribute("data-large");
    // update label
    modalLabel.textContent = thumb
      .closest(".fashion-gallery-item")
      .querySelector(".look-label").textContent;
  });

  document.addEventListener("keydown", (e) => {
    if (!modal.classList.contains("hidden") && e.key === "Escape") {
      modal.classList.add("hidden");
    }
  });
});
